import { useEffect, useState, ReactElement } from 'react'
import { IdValueGeneric } from 'interfaces'
import { Select } from '../../../ui-components'
import { ListItem } from '../interfaces'

interface SelectWrapperProps {
  options: ListItem[]
  onSelect: (selectedOptions: ListItem[]) => void
}

interface IdValueGenericWithActive<S, T> extends IdValueGeneric<S, T> {
  active?: boolean
}

type SelectOption = IdValueGenericWithActive<string | number, string>

export const SelectWrapper = ({
  options,
  onSelect,
}: SelectWrapperProps): ReactElement => {
  const [selectOptions, setSelectOptions] = useState<SelectOption[]>([])
  const [selection, setSelection] = useState<SelectOption>({
    id: '',
    value: '',
  })

  const handleSelection = (data: SelectOption) => {
    onSelect([
      {
        value: data.id,
        label: data.value,
        active: true,
      },
    ])
  }

  useEffect(() => {
    setSelectOptions(
      options.map((option) => ({
        id: option.value,
        value: option.label,
        active: option.active,
      }))
    )
  }, [options])

  useEffect(() => {
    setSelection(
      selectOptions.find((option) => option.active) || selectOptions[0]
    )
  }, [selectOptions])

  return (
    <Select
      width="220px"
      optionFontSize="16px"
      options={selectOptions}
      selectedOption={selection}
      onSelect={handleSelection}
    />
  )
}
